export const VERSION_APP = '0.0.9'
export const VERSION_LIST = '0.0.3' // 更改此值会使客户端之前的list缓存失效，请保持递增
